// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"_shipping-information-SubmitButton-module--submit-button--iOFAY"};